<template>
  <div v-show="isShow" class="main">
    <div class="close" @click="closeVideo">
      <close theme="outline" size="30" fill="#ffffff" :strokeWidth="2" />
    </div>
    <a-row type="flex" class="dialog" align="middle">
      <a-col :span="24">
        <!-- <img class="close" src="" /> -->
        <div class="dialog-content">
          <video ref="dialog" :src="src" controls type="video/mp4">您的浏览器不支持 video 标签。</video>
        </div>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import { Close } from '@icon-park/vue'
export default {
  components: {
    Close,
  },
  props: {
    src: {
      type: String,
      default: '',
    },
  },
  watch: {
    isShow(value) {
      value ? this.$refs.dialog.play() : this.$refs.dialog.pause()
    },
  },
  data() {
    return {
      isShow: false,
    }
  },
  methods: {
    closeVideo() {
      this.isShow = false
      this.$refs.dialog.load()
    },
  },
}
</script>
<style lang="stylus" scoped>
.main
  position fixed
  top 0
  z-index 100
  width 100%
  height 100%
  background-color rgba(0, 0, 0, 0.7)
  .close
    position absolute
    height 30px
    width 30px
    top 130px
    right 30px
    cursor pointer
    z-index 100
  .dialog
    height 100%
    .dialog-content
      margin 0 auto
</style>
